import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UnifiedLoginService } from '../../unified-login/unified-login.service';
import {
  TREQUEST_AqlLevel,
  TRESPONSE_AqlLevel,
  TREQUEST_AqlMeasurement,
  TRESPONSE_AqlMeasurement,
  TREQUEST_AqlPom,
  TRESPONSE_AQL_FILTERS_SEARCH_RES,
  TRESPONSE_AqlPom,
  TREQUEST_DeletePomRow,
  TREQUEST_EditPomRow,
  TRESPONSE_EditPomRow,
  TREQUEST_GetFiltersList,
  TAqlLevelRowDeletePayload,
  TAqlLevelRequestPayload,
  TAqlFilterSearchResult,
  TRESPONSE_DepartmentList,
  TFeatureOptionsAql,
} from '@monorepo/types';
import { AqlEndPoint, AqlEnvProvider } from './aql.env.provider';

@Injectable({
  providedIn: 'root',
})
export class AqlListDataProvider {
  constructor(
    private http: HttpClient,
    private aqlEnvProvider: AqlEnvProvider,
    public unifiedLoginService: UnifiedLoginService,
  ) {}

  fetchDepartmentsList(factoryId: string, feature: TFeatureOptionsAql) {
    const URL = this.aqlEnvProvider.getUrlFromEnv('GET_DEPARTMENTS_LIST') + `/${factoryId}/${feature}`;
    return this.http.post<TRESPONSE_DepartmentList>(URL, {});
  }

  fetchAqlLevelListData(payload: TREQUEST_AqlLevel) {
    const url = this.aqlEnvProvider.getUrlFromEnv('GET_AQL_LEVEL');
    return this.http.post<TRESPONSE_AqlLevel>(url, payload);
    // return of(aqlLevelList);
  }

  addEditAqlLevel(payload: TAqlLevelRequestPayload) {
    const url = this.aqlEnvProvider.getUrlFromEnv('EDIT_AQL_LEVEL');
    return this.http.post<TRESPONSE_AqlLevel>(url, payload);
  }

  deleteAqlLevel(payload: TAqlLevelRowDeletePayload) {
    const url = this.aqlEnvProvider.getUrlFromEnv('DELETE_AQL_LEVEL');
    return this.http.post<TRESPONSE_AqlLevel>(url, payload);
  }

  fetchAqlMeasurementListData(payload: TREQUEST_AqlMeasurement) {
    const url = this.aqlEnvProvider.getUrlFromEnv('GET_AQL_MEASUREMENT');
    return this.http.post<TRESPONSE_AqlMeasurement>(url, payload);
    // return of(aqlMeasurementList);
  }

  fetchAqlPomListData(payload: TREQUEST_AqlPom) {
    const url = this.aqlEnvProvider.getUrlFromEnv('GET_AQL_POM');
    return this.http.post<TRESPONSE_AqlPom>(url, payload);
    // return of(aqlPomList);
  }

  editAqlPom(payload: TREQUEST_EditPomRow) {
    const url = this.aqlEnvProvider.getUrlFromEnv('EDIT_AQL_POM');
    return this.http.post<TRESPONSE_EditPomRow>(url, payload);
  }

  deleteAqlPom(payload: TREQUEST_DeletePomRow) {
    const url = this.aqlEnvProvider.getUrlFromEnv('DELETE_AQL_POM');
    return this.http.post<TRESPONSE_EditPomRow>(url, payload);
  }

  getFiltersSearchResults(endPoint: keyof typeof AqlEndPoint, payload: TAqlFilterSearchResult) {
    const { factoryId } = this.unifiedLoginService.getUserInfo();
    const url = this.aqlEnvProvider.getUrlFromEnv(endPoint).replace(':factoryId', factoryId);
    return this.http.post<TRESPONSE_AQL_FILTERS_SEARCH_RES>(url, payload);
  }

  getDropdownResults(payload: TREQUEST_GetFiltersList) {
    const { factoryId } = this.unifiedLoginService.getUserInfo();
    const url = this.aqlEnvProvider.getUrlFromEnv('SEARCH_BCTX').replace(':factoryId', factoryId);
    return this.http.post<TRESPONSE_AQL_FILTERS_SEARCH_RES>(url, payload);
  }

  getAqlLevelDownloadSampleFileUrl(): string {
    return this.aqlEnvProvider.getUrlFromEnv('DOWNLOAD_AQL_LEVEL_TEMPLATE');
  }

  getAqlLevelUploadFile() {
    return this.aqlEnvProvider.getUrlFromEnv('UPLOAD_AQL_LEVEL_EXCEL');
  }

  DownloadAqlLevelData(params: { factoryId: string; departmentId: string }): string {
    return `${this.aqlEnvProvider.getUrlFromEnv('DOWNLOAD_AQL_LEVEL_LIST')}/${params.factoryId}/${params.departmentId}`;
  }

  getErrorFileUrl(errorFileKey: string) {
    // return `${this.aqlEnvProvider.getUrlFromEnv('DOWNLOAD_ERROR_FILE')}${errorFileKey}`;
  }

  getAQLLevelErrorFileUrl(errorFileKey: string) {
    return `${this.aqlEnvProvider.getUrlFromEnv('AQL_UPLOAD_ERROR_FILE')}${errorFileKey}`;
  }

  getAQLPomErrorFileUrl(errorFileKey: string) {
    return `${this.aqlEnvProvider.getUrlFromEnv('POM_UPLOAD_ERROR_FILE')}${errorFileKey}`;
  }

  getAqlPomFileUrl() {
    return `${this.aqlEnvProvider.getUrlFromEnv('DOWNLOAD_AQL_POM')}`;
  }

  getAqlPomSampleFile() {
    return `${this.aqlEnvProvider.getUrlFromEnv('DOWNLOAD_AQL_POM_TEMPLATE')}`;
  }

  getAqlPomUploadFile() {
    return this.aqlEnvProvider.getUrlFromEnv('UPLOAD_POM_EXCEL');
  }
}
